var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Copyright ©2020 - "+_vm._s(_vm.year)+" nuxtation project.")])}
var staticRenderFns = []

export { render, staticRenderFns }